import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { actualizarMovDiariosExp } from '../../actions/listados'
import MovimientosDiariosExportadorView from './MovimientosDiariosExportadorView'
import { COLORES } from '../../../../config/colores'

function DetalleMovimientosDiariosExportador (props) {
  const { detalle, actualizarMovDiariosExp } = props

  useEffect(() => {
    const cereal = detalle['cereal']
    const exportador = detalle['razonSocialExportador']
    const fechaD = detalle['fechaDesde']
    const fechaH = detalle['fechaHasta']
    actualizarMovDiariosExp(fechaD, fechaH, exportador, cereal, detalle['almacenaje'])
  }, [detalle, actualizarMovDiariosExp])

  return (
    <>
      <h6 style={{ padding: '0 10px' }}>Exportador:  <b>{detalle['razonSocialExportador']}</b></h6>
      <h6 style={{
        backgroundColor: COLORES.grey.dark,
        color: 'white',
        borderRadius: '12px',
        padding: '10px'
      }}>
                Total acumulado: <b>{(detalle.almacenaje).toLocaleString('es-ES')} kg.</b>
      </h6>

      <MovimientosDiariosExportadorView />
    </>
  )
}

const mapActionsToProps = {
  actualizarMovDiariosExp
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(DetalleMovimientosDiariosExportador)
